import ChangePasswordPage, { ChangePasswordPageProps } from './ChangePasswordPage';

export type { ChangePasswordPageProps };
export default ChangePasswordPage;
